import React from 'react';
import { Box, Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const defaultPageSpacing = {
  mt: { xs: 3, sm: 4, md: 4 },
  mb: { xs: 3, sm: 4, md: 4 },
};

const PageShell = ({
  children,
  maxWidth = 'lg',
  disableGutters = false,
  sx = {},
  containerSx = {},
  gap,
}) => {
  const theme = useTheme();
  const pageSpacing = theme.layout?.pageShell ?? defaultPageSpacing;

  return (
    <Box sx={{ width: '100%', boxSizing: 'border-box', ...sx }}>
      <Container
        maxWidth={maxWidth}
        disableGutters={disableGutters}
        sx={{
          ...pageSpacing,
          ...(gap ? { display: 'flex', flexDirection: 'column', gap } : {}),
          ...containerSx,
        }}
      >
        {children}
      </Container>
    </Box>
  );
};

export default PageShell;
